import React from 'react';
import { Input } from 'components/atoms/input';
import { KeyCodes } from '../edit-space';
import { NewSpaceTypes } from './new-space.types';

export const NewSpace = ({
  space,
  onChange,
  onCancel,
  isLoading,
}: NewSpaceTypes) => {
  const handleCreate = (sapceName = '') => {
    if (sapceName.trim()) {
      onChange?.({
        ...space,
        spaceName: sapceName,
      });
    } else {
      onCancel(space);
    }
  };

  const handleOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    handleCreate(e.currentTarget.value);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === KeyCodes.Esc) {
      onCancel(space);
    }
  };

  const handleOnBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleCreate(e.currentTarget.value);
  };

  return (
    <Input
      data-test-id="projects.space.new.input"
      key="0"
      autoFocus
      size="small"
      onBlur={handleOnBlur}
      onPressEnter={handleOnEnter}
      onKeyDown={handleOnKeyDown}
      disabled={isLoading}
    />
  );
};
